export default "__VITE_PUBLIC_ASSET__6c1ce9c4__"